import { cn } from "@/lib/utils";
import type { MentionComposer } from "@/hooks/use-mention-composer";

interface MentionListboxProps {
  composer: MentionComposer;
  className?: string;
}

/** @-listen over et kommentarfelt. Rendres bare når `composer.mentionsOpen`. */
export function MentionListbox({ composer, className }: MentionListboxProps) {
  if (!composer.mentionsOpen) return null;
  return (
    <div
      id={composer.listboxId}
      role="listbox"
      aria-label="Tagg en person"
      className={cn(
        "absolute bottom-full mb-1 left-0 w-64 bg-popover border rounded-md shadow-lg max-h-40 overflow-y-auto z-10",
        className,
      )}
    >
      {composer.visibleUsers.map((u, i) => {
        const selected = u.id === composer.highlightedUser?.id;
        return (
          <button
            key={u.id}
            id={composer.optionId(u.id)}
            role="option"
            aria-selected={selected}
            tabIndex={-1}
            className={cn(
              "w-full text-left px-3 py-2 text-sm hover:bg-muted flex items-center gap-2",
              selected && "bg-muted",
            )}
            onMouseEnter={() => composer.setHighlighted(i)}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => composer.insertMention(u)}
          >
            {u.avatar_url ? (
              <img src={u.avatar_url} alt="" className="w-5 h-5 rounded-full" />
            ) : (
              <span className="w-5 h-5 rounded-full bg-primary/10 text-primary text-[10px] font-medium flex items-center justify-center">
                {u.full_name[0]}
              </span>
            )}
            {u.full_name}
          </button>
        );
      })}
    </div>
  );
}
